import { CustomersEndpoint as CustomersEndpointInterface } from '@apiClient/interfaces/endpoints/Customers.endpoint';
import { buildSearchParams } from '@/utils/handlers/urlHandler';
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from 'ky';
import ApiResponseDto from '@/projectRoot/api-client/interfaces/response/ApiResponse.dto';
import CustomerDto from '@/projectRoot/api-client/interfaces/models/customers/Customer.dto';
import CustomerRequestDto from '@/projectRoot/api-client/interfaces/request/customers/CustomerRequest.dto';

export class CustomersEndpoint implements CustomersEndpointInterface {
   
    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = process.env.NEXT_PUBLIC_ENVIRONMENT == 'staging' ? "no-store" : "force-cache") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
    * /api/customers
    */
    async getCustomers(params?: CustomerRequestDto): Promise<ApiResponseDto<CustomerDto[], undefined>> {
        return this._httpClient
            .get(`customers`, { searchParams: params ? buildSearchParams(params) : {}, cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    
}

export default CustomersEndpoint;